/*
 *  Copyright 2014 NHN Entertainment Corp. All rights Reserved.
 *  NHN Entertainment PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 *
 *   @author changyoun.seo@nhnedu.com
 *   @since 2/18/20 3:37 PM
 *   @desc
 */

import $ from './jquery';

export const isMobile = () => (/iphone|ipad|ipod|android/i.test(navigator.userAgent.toLowerCase()));

export const switchByUserAgent = () => {
    if (isMobile()) {
        console.log(`let's Mobile mode`);
        $('[data-mobile]').show();
    } else {
        console.log(`let's PC mode`);
        $('[data-pc]').show();
    }
};
